// TODO: update pluralize to support different languages
export var pluralize = function pluralize(singular, plural, count) {
  return count === 1 ? singular : plural;
};